import { createSlice } from "@reduxjs/toolkit";

// Old code made by mansicarpermint, we need to refactor this when we have time.
// TODO: Refactor, Update:
// - The name of the reducer to be more descriptive.
// - The name of the actions to be more descriptive.
// - The functions of the actions for updating a specific part of the state to be more descriptive.

const user = createSlice({
    name: 'user',
    initialState: {},
    reducers: {
        resetStore: () => { return {} },
        setQualificationStore: (state, action) => ({ ...state, ...action.payload }),
        setShippingAddressStore: (state, action) => ({ ...state, ...action.payload }),
        setValue: (state, action) => ({ ...state, ...action.payload }),
        setKiosk: (state, action) => ({ ...state, ...action.payload }),
        setSignupData: (state, action) => ({ ...state, signUpData: {...state.signUpData, ...action.payload} }),
    }
})
export const {
    resetStore,
    setQualificationStore,
    setShippingAddressStore,
    setValue,
    setKiosk,
    setSignupData,
} = user.actions
export default user.reducer;

